export enum Unread {
  /** 未读 */
  Send = 'send',
  /** 已读 */
  Read = 'read',
}
